import React from 'react'

import { Banner } from './index.styled'

const ClosingBannerHeader = ({ isHome = false }) => {
  return (
    <Banner id='banner-header' className={isHome ? 'home homeStart' : ''}>
      Immediate Occupancy
    </Banner>
  )
}

export default ClosingBannerHeader
